import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { RootState } from '@/redux/reducer/reducer';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { token, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const { routerLinks } = useSelector((state: RootState) => state.router);
  const location = useLocation();
  
  const [isTokenValid, setIsTokenValid] = useState<boolean>(true);
  const [isRoutesLoaded, setIsRoutesLoaded] = useState<boolean>(false);

  useEffect(() => {
    console.log("ProtectedRoute Check:", isAuthenticated, isTokenValid);

    if (token) {
      try {
        const decodedToken: any = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Convert to seconds
        setIsTokenValid(decodedToken.exp >= currentTime);
      } catch (error) {
        console.log('Invalid token:', error);
        setIsTokenValid(false);
      }
    } else {
      console.log('No token found');
      setIsTokenValid(false);
    }
  }, [token, isAuthenticated]);

  // Track when routerLinks gets updated
  useEffect(() => {
    if (routerLinks && routerLinks.length > 0) {
      setIsRoutesLoaded(true);
    }
  }, [routerLinks]);

  // If not authenticated or token is invalid, redirect to sign-in
  if (!isAuthenticated || !isTokenValid) {
    console.log('User is not authenticated or token is invalid, redirecting to /sign-in');
    return <Navigate to="/sign-in" />;
  }

  // Wait for routerLinks to load before checking access
  if (!isRoutesLoaded) {
    console.log("Waiting for routerLinks to load...");
    return null; // or a loading spinner
  }

  // Normalize path and check access
  const normalizedPath = location.pathname.trim().replace(/^\/+/, '')?.toLowerCase();
  const normalizedRouterLinks = routerLinks?.map(link => link.routerLink?.toLowerCase());


console.log("Normalized Path:", normalizedPath);
console.log("Available Routes:", normalizedRouterLinks);
console.log("Access Granted:", normalizedRouterLinks.includes(normalizedPath));

if (!normalizedRouterLinks.includes(normalizedPath)) {
  console.log(`Access denied for ${location.pathname}`);
  return <Navigate to="/access-denied" />;
}

  return <>{children}</>;
};

export default ProtectedRoute;
